import * as React from 'react';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import { t } from 'utils/language';

type Props = {
  actionButton?: React.ReactNode
};

const TooManyFollowersMessage = ({
  actionButton
}: Props) => (
  <div className="too-many-followers">
    <div className="too-many-followers__image" />
    <p className="too-many-followers__line1">{t('statistics.audience.overlap.too_many_followers.line1')}</p>
    <p className="too-many-followers__line2">
      {t('statistics.audience.overlap.too_many_followers.line2', {
        maxFollowers: `40 ${t('statistics.audience.overlap.too_many_followers.label_million')}`
      })}
    </p>
    {actionButton &&
      <React.Fragment>
        <VerticalSpacing type="large" />
        {actionButton}
      </React.Fragment>
    }
  </div>
);

export default TooManyFollowersMessage;
